import React, {useState,useEffect} from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { getUserSchemeApplications } from "../../../services/schemeApiService/SchemeApiService";

const toTitleCase = (str) => {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  };

function ApplicationHistoryTable({scheme}) {

    const navigate = useNavigate();

    const [applications, setApplications] = useState([
        // {
        //   id: 'S001',
        //   name: 'Devbhoomi Uttarakhand Khel Ratna Award',
        //   date: '24 Mar, 2025',
        //   status: 'Approved',
        // },
        // {
        //   id: 'S001',
        //   name: 'Devbhoomi Uttarakhand Khel Ratna Award',
        //   date: '24 Mar, 2025',
        //   status: 'Pending',
        // },
        // {
        //   id: 'S001',
        //   name: 'Devbhoomi Uttarakhand Khel Ratna Award',
        //   date: '24 Mar, 2025',
        //   status: 'Approved',
        // },
    ]);

    const statusStyle = {
        Approved: 'bg-green-100 text-green-600 border border-green-400',
        Pending: 'bg-yellow-100 text-yellow-600 border border-yellow-400',
    };

    function handleViewApplication(applicant_id){
        let secretKey = process.env.REACT_APP_SECRET_KEY ;
        let encryptedId = encodeURIComponent(CryptoJS.AES.encrypt(applicant_id.toString(), secretKey).toString());
        navigate(`/grant-scheme/submitted-form/${encryptedId}`);
    }

    const fetchApplicationHistory = async () => {
        try {
            const response = await getUserSchemeApplications(scheme.id);
            // setApplications(response.data.data);
            // console.log(response.data.data);

            let transformedData = response.data.data.map((item, index) => ({
                // id: `S${String(item.id).padStart(3, '0')}`, // e.g., 83 -> S083
                id: item.id,
                name: scheme.title,
                date: new Date(item.createdAt).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                }), // e.g., "22 Apr, 2025"
                status: item.status === 'final_submit' ? 'pending' // Custom logic for status
                : item.status === 'verified' ? 'verified'
                : item.status === 'approved' ? 'approved'
                : item.status === 'rejected' ? 'rejected'
                : item.status === 'ongoing' ? 'ongoing'
                : item.status 
              }));

            setApplications(transformedData);


        } catch (error) {
            console.error("Error fetching application history:", error);
        }
    }

    useEffect(()=>{
        fetchApplicationHistory();
    },[]);

  return (
    <>
    {applications.length > 0 ? (
    <div className="table-container">
    <table className="application-table">
        <thead>
        <tr>
            <th>Application ID</th>
            <th>Application Name</th>
            <th>Submitted On</th>
            <th>Status</th>
            <th>Action</th>
        </tr>
        </thead>
        <tbody>
            {applications.map((item)=>(
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.name}</td>
                    <td>{item.date}</td>
                    <td><span className={`status ${item.status}`}>{toTitleCase(item.status)}</span></td>
                    <td><a  className="view-link" onClick={()=>{handleViewApplication(item.id)}}>View Application</a></td>
                </tr>
            ))}
        </tbody>
    </table>
    </div>
    ) : (
        <></>
    )}
    </>
  )
}

export default ApplicationHistoryTable